export const API_GET_VOUCHER_AUTHORIZED = "/comprobantes/recibidos/";


export const API_GET_SEARCH_AUTHORIZED='/comprobantes/recibidos/busqueda/';
